import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import { AddAppUserModal } from 'features/users/components/modals/add-app-user-modal';
import { EndUsersFilterForm } from 'features/users/components/users-filter-form/end-users-filter-form';
import { EndUserFilterFormValues } from 'features/users/components/users-filter-form/types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES, SideBarMenus } from 'routes/constants'
import { CompanyType } from 'types';
import { HasPermission } from 'utils/CheckPermissions';
const { useBreakpoint } = Grid;

type UsersTopBarProps = {
  getInitialFilterValues: EndUserFilterFormValues;
  handleFilter: (values: EndUserFilterFormValues) => void;
  userEditData: any;
  onRefresh :  () => void ;
  isFetching : boolean ;

};

export const EndUsersTopBar = ({
  getInitialFilterValues,
  handleFilter,
  userEditData,
  onRefresh 
  

}: UsersTopBarProps) => {
  useState<CompanyType>();
  const { t } = useTranslation();
  const formId = 'end-users-filters-form';
  const [showAppUserModal, setShowAppUserModal] = useState(false);
  const screens = useBreakpoint();
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setShowAppUserModal(false);
    document.body.style.overflow = 'visible';
  }

  const handleOpenModal = () => {
    setShowAppUserModal(true);
    document.body.style.overflow = 'hidden';
  }

  const handleOpenRoleManagement = () => {
    navigate(ROUTES.RoleManagement);
  }

  return (
    <>
      <div className={`cstmrightmdl ${showAppUserModal && "show"}`}>
        <AddAppUserModal onClose={handleCloseModal} userEditData={userEditData} />
      </div>

      <ContentTopBar title={t('adminUsers.heading.Atulit-admin')}
        renderButtons={
          <div className='flex flex-nowrap"'>
            {HasPermission(SideBarMenus.ADMIN, 'add') ? (
              <Button
                icon={!screens.xs ? <PlusOutlined /> : undefined}
                type='primary'
                onClick={handleOpenModal}
                style={{ marginRight: 10 }}
              >
                {t('adminUsers.addNewUser')}
              </Button>
            ) : null}

            {HasPermission(SideBarMenus.ADMIN, 'add') ? (
              <Button
                icon={!screens.xs ? <PlusOutlined /> : undefined}
                type='primary'
                onClick={handleOpenRoleManagement}
              >
                {t('adminUsers.manageRoles')}
              </Button>
            ) : null}
          </div>
        }
      />
      <ContentFilters formId={formId}>
        <EndUsersFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
          onRefresh={onRefresh}
       
        />
      </ContentFilters>
    </>
  );
};
